import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectSampleOnboardingRoute: InvariantJiraRoute = {
	name: 'classic-business-sample-onboarding',
	path: '/jira/core/sample/onboarding/:taskId',
	exact: true,
};
